import { gql } from '@apollo/client'

// Create new explore item
export const CREATE_EXPLORE_ITEM = gql`
    mutation createExploreItem($exploreItem: ExploreItemInput!) {
        createExploreItem(explore_item: $exploreItem) {
            code
            success
            message
        }
    }
`

// Update explore item
export const UPDATE_EXPLORE_ITEM = gql`
    mutation updateExploreItem($itemId: NonEmptyString!, $exploreItem: ExploreItemInput!) {
        updateExploreItem(item_id: $itemId, explore_item: $exploreItem) {
            code
            success
            message
        }
    }
`

// Update explore item active status
export const UPDATE_ACTIVE_EXPLORE_ITEM = gql`
    mutation updateActiveExploreItem($itemId: NonEmptyString!, $isActive: Boolean!) {
        updateActiveExploreItem(item_id: $itemId, is_active: $isActive) {
            code
            success
            message
        }
    }
`
